module.exports = __webpack_public_path__ + "static/media/star-icon-dark.85335c94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/star-icon-dark.svg
// module id = ./src/assets/images/star-icon-dark.svg
// module chunks = 0